import authApi from "api/landlord/auth";
import { Link, useNavigate } from "react-router-dom";
import { useAuthContext } from "providers/Auth";
import { Button, ButtonSize, ButtonVariant, Input } from "shared/components";
import { useForm } from "shared/hooks";
import logoSquare from "shared/branding/logo-square.svg";

import { getErrorMessage } from "utils/error";

import { object, string } from "yup";
import { toast } from "react-toastify";

const login = object({
  email: string().email().required("Email is required"),
  password: string().required("Password is required")
});

export const Login = () => {
  const { refreshAuth } = useAuthContext();
  const navigate = useNavigate();

  const { values, register, isSubmitting, onSubmit } = useForm(
    {
      email: "",
      password: ""
    },
    login
  );

  const onLoginClicked = async () => {
    try {
      await authApi.login(values.email, values.password);
      await authApi.checkAuth();

      await refreshAuth();

      navigate("/");
    } catch (e) {
      toast.error(getErrorMessage(e));
    }
  };

  return (
    <div className="animate-appear flex min-h-screen items-center justify-center bg-background-900 p-2">
      <div className="h-full w-full max-w-[400px] rounded-lg border border-alpha-100 bg-background-1000 p-8 shadow-xl">
        <div className="flex items-center gap-4">
          <img alt="Boom logo" className="h-10 w-10" src={logoSquare} />
          <div>
            <p className="text-base font-bold">Boom</p>
            <p className="text-sm font-medium text-content-200">
              for Property Managers
            </p>
          </div>
        </div>
        <div className="my-6 border-b border-alpha-40" />
        <p className="mb-6 text-xl font-bold text-content-1000">
          Log in to your account
        </p>
        <form
          onSubmit={onSubmit({
            onSuccess: onLoginClicked
          })}
        >
          <Input
            id="email"
            label="Email"
            placeholder="example@gmail.com"
            required={true}
            {...register("email")}
          />
          <Input
            id="password"
            type="password"
            label="Password"
            placeholder="·············"
            required={true}
            {...register("password")}
          />
          <div className="flex justify-end">
            <Link
              className="cursor-pointer text-xs font-bold text-primary-500"
              to="/forgot-password"
            >
              Forgot password?
            </Link>
          </div>

          <Button
            variant={ButtonVariant.PRIMARY}
            size={ButtonSize.BASE}
            className="mb-4 mt-6 w-full"
            type="submit"
            loading={isSubmitting}
          >
            Sign in
          </Button>
        </form>

        <p className="text-center text-sm font-medium text-content-400">
          Don&apos;t have an account?{" "}
          <Link
            className="cursor-pointer text-sm font-bold text-primary-500"
            to="/sign-up"
          >
            Sign up
          </Link>
        </p>
      </div>
    </div>
  );
};
